module.exports = __webpack_public_path__ + "static/media/no-access.d51c77db.svg";